import { IStatsCompanyByPatients } from 'interfaces/global/globalInterfaces';
import { StatsCompanyByPatients } from 'interfaces/hooks/companiesHooksInterfaces';
import { getDecimalLength } from './getDecimalLength';

export const calculateStatsPercentages = (data: StatsCompanyByPatients['data']): IStatsCompanyByPatients => {
  const agesGroups: number[] = [data.less_30, data.more_30_and_less_45, data.more_45_and_less_60, data.more_60];
  const sumOfGroups = agesGroups.reduce((a, b) => a + b, 0);
  const commonGroup = Math.max(...agesGroups);
  const commonGroupIndex = agesGroups.indexOf(commonGroup);
  const decimal = getDecimalLength(sumOfGroups);

  agesGroups.splice(commonGroupIndex, 1);
  agesGroups.forEach((item, index) => {
    agesGroups[index] = parseFloat(((item / sumOfGroups) * 100).toFixed(sumOfGroups <= 99 ? 0 : decimal));
  });

  const commonGroupPercent = parseFloat((100 - agesGroups.reduce((a, b) => a + b, 0)).toFixed(2));
  agesGroups.splice(commonGroupIndex, 0, commonGroupPercent);

  return {
    men_percentage: data.men_percentage,
    less_30: agesGroups[0],
    more_30_and_less_45: agesGroups[1],
    more_45_and_less_60: agesGroups[2],
    more_60: agesGroups[3],
    total_registered: sumOfGroups,
    women_percentage: data.women_percentage,
  };
};
